/**
* 班级任务与个人完成情况
*/
<template>
    <span>
        <a @click="openmodel()">详情</a>
        <a-modal :visible="visible" :width="1280" title="老师工资详情" @ok="okmodel" @cancel="cancelmodel">
            <a-row :gutter="16" style="margin-left: 50px">
                <a-col :span="6" v-for="(item) in tongji" :key="item.mission_type">
                    <a-statistic :title="item.mission_type_name" :value="item.money">

                    </a-statistic>
                </a-col>
            </a-row>
            <a-form layout="inline">
                <a-form-item>
                    <a-range-picker :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm"
                        :placeholder="['开始时间', '结束时间']" @change="onChange" />
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
                </a-form-item>
            </a-form>
            <a-divider></a-divider>
            <div>
                <a-table :dataSource="tabledata" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
                    @change="onPaginationChange" bordered>
                    <a-table-column key="org_name" title="机构" data-index="org_name" />
                    <a-table-column key="campus_name" title="校区" data-index="campus_name" />
                    <a-table-column key="student_name" title="学生姓名" data-index="student_name" />
                    <a-table-column key="mission_name" title="任务名字" data-index="mission_name" />
                    <a-table-column key="mission_type_name" title="任务类型" data-index="mission_type_name" />

                    <a-table-column key="money" title="金额" data-index="money" />
                    <a-table-column key="create_time" title="时间">
                        <template slot-scope="item">
                            <span>{{ moment(item.create_time * 1000).format('YYYY-MM-DD') }}</span>
                        </template>
                    </a-table-column>
                </a-table>
                <div>总共{{ pageinfo.total }}条数据</div>
                <a-switch size="small" v-model="showcount" @change="getshowcount" />
            </div>

        </a-modal>
    </span>
</template>
<script>
import moment from "moment";
export default {
    components: {


    },
    props: {
        itemdata: {},
        // searchFrom:{}
    },
    data() {
        return {
            data: [],
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 10
            },
            tongji: [],
            searchFrom: {
                teacher_id: undefined,
                start_time: undefined,
                end_time: undefined,
                mission_type: undefined,
            },
            showcount: false,
            tabledata: [],
            loading: false,
            visible: false,
            squadinfo: [],
        };
    },
    mounted() {

    },
    computed: {
        rowSelection() {
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    selectedRows;
                },

            };
        },
    },
    methods: {

        tableSearch() {
            this.getTableList();
        },
        getshowcount() {
            if (this.showcount) {
                this.pageinfo.pageSize = 100;
                this.pageinfo.current = 1;
            }
            if (!this.showcount) {
                this.pageinfo.pageSize = 10;
                this.pageinfo.current = 1;
            }
            this.getTableList();
        },
        onChange(value, dateString) {
            dateString,
                this.searchFrom.start_time = Number(value[0] / 1000);
            this.searchFrom.end_time = Number(value[1] / 1000);
        },
        getTableList() {
            //  console.log("sss");
            this.searchFrom.teacher_id = this.itemdata.teacher_id;
            this.loading = true;
            this.$axios
                .post("/api/TeacherPerformance/getPerformanceDetail", {
                    data: this.searchFrom,
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                        this.tabledata = null;
                    } else {
                        this.tabledata = res.data.data;
                        this.tongji = res.data.tongji;
                        this.pageinfo = res.data.pageinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        },

        openmodel() {
            this.visible = true;

            this.getTableList();
        },
        okmodel() {
            this.visible = false;
        },
        cancelmodel() {
            this.visible = false;
        },

        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getTableList();
        },
        moment

    }
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>
